import { useCallback, useState } from "react";
import { UpdateAttribute } from "./useAttributes";

export type SysAttributesHandlers<Attribute> = {
  setSysAttributes?: (attributes: Attribute[]) => void;
  addSysAttributes?: (attributes: Attribute[]) => void;
  deleteSysAttribute?: (id: string) => void;
  updateSysAttribute?: UpdateAttribute<Attribute>;
};

export const useSysAttributes = <Attribute extends { id?: string }>(
  initialSysAttributes: Attribute[] = [],
): [Attribute[], SysAttributesHandlers<Attribute>] => {
  const [sysAttributes, setSysAttributes] = useState<Attribute[]>(initialSysAttributes);
  const addSysAttributes = useCallback(newSysAttributes => {
    setSysAttributes(sysAttributesState => [...sysAttributesState, ...newSysAttributes]);
  }, []);
  const deleteSysAttribute = useCallback(idToRemove => {
    setSysAttributes(sysAttributesState => sysAttributesState.filter(({ id }) => id !== idToRemove));
  }, []);
  const updateSysAttribute = useCallback<UpdateAttribute<Attribute>>((id, attributeUpdate) => {
    setSysAttributes(sysAttributesState =>
      sysAttributesState.map(sysAttribute =>
        sysAttribute.id !== id ? sysAttribute : { ...sysAttribute, ...attributeUpdate },
      ),
    );
  }, []);

  return [sysAttributes, { addSysAttributes, deleteSysAttribute, updateSysAttribute, setSysAttributes }];
};
